const setDocumentTitle = title => {
  return ({ next }) => {
    document.title = title;

    return next();
  };
};

export default setDocumentTitle;
